import axios from 'axios';

// const baseURL = `http://localhost:5000`;
const baseURL = `https://admin.environaturesolution.com`;

export default axios.create({
  baseURL: baseURL
});

export const apiUrl = baseURL;
